import Link from 'next/link';
import {
  PAYWALL_LINKS,
  PAYWALL_SUPPORT_EMAIL,
} from '@/features/tool/constants/paywall';

const Paywall2LegalText = ({
  hasTrial,
  trialDurationText,
  dueTodayAmountText,
  recurringAmountText,
  recurringPeriodText,
}: {
  hasTrial: boolean;
  trialDurationText: string;
  dueTodayAmountText: string;
  recurringAmountText: string;
  recurringPeriodText: string;
}) => (
  <p className="text-[14px] leading-5 text-[#787887]">
    By continuing, you agree that you will be charged{' '}
    {hasTrial && trialDurationText ? (
      <>
        {dueTodayAmountText} today for a {trialDurationText} trial and{' '}
        {recurringAmountText} automatically every {recurringPeriodText}{' '}
        thereafter unless you cancel before your trial ends.
      </>
    ) : (
      <>
        {recurringAmountText} automatically every {recurringPeriodText} unless
        you cancel before your next renewal.
      </>
    )}{' '}
    You can cancel your auto-renewing subscription through your online account.
    You also agree to our{' '}
    <Link
      href={PAYWALL_LINKS.terms}
      target="_blank"
      className="text-[#4B7EFF] underline"
    >
      Terms and Conditions
    </Link>
    ,{' '}
    <Link
      href={PAYWALL_LINKS.privacy}
      target="_blank"
      className="text-[#4B7EFF] underline"
    >
      Privacy Policy
    </Link>
    ,{' '}
    <Link
      href={PAYWALL_LINKS.subscription}
      target="_blank"
      className="text-[#4B7EFF] underline"
    >
      Subscription Policy
    </Link>
    , and{' '}
    <Link
      href={PAYWALL_LINKS.refund}
      target="_blank"
      className="text-[#4B7EFF] underline"
    >
      Refund Policy
    </Link>
    . For customer support, please email us at{' '}
    <a
      href={`mailto:${PAYWALL_SUPPORT_EMAIL}`}
      className="text-[#4B7EFF] underline"
    >
      {PAYWALL_SUPPORT_EMAIL}
    </a>
    .
  </p>
);

export default Paywall2LegalText;
